<mat-card>
    <div class="product-wrapper" style="position: relative" *ngIf="stateData?.price_with_assistance">
        <div class="product-header" *ngIf="stateData?.withAssistance">
            <h3>Seguro a terceros con asistencia</h3>
            <div class="price-container">{{ stateData?.price_with_assistance?.primaTotal | number:'1.2-2' }} €</div>
        </div>
        <div class="product-header" *ngIf="!stateData?.withAssistance">
            <h3>Seguro a terceros</h3>
            <div class="price-container">{{ stateData?.price_without_assistance?.primaTotal | number:'1.2-2' }} €</div>
        </div>
        <div class="preview-data-wrapper">
            <div class="preview-data-item">
                <span class="preview-data-label">Días contratados</span>
                <span class="preview-data-value">{{ stateData?.duration }} {{ stateData?.duration > 1 ? 'días' : 'día'
                    }}</span>
                <mat-icon class="edit-icon" (click)="goToForm()">edit</mat-icon>
            </div>
            <div class="preview-data-item">
                <span class="preview-data-label">Fecha de inicio - fin del seguro</span>
                <span class="preview-data-value">{{ stateData?.start_date | date }} - {{ stateData?.end_date | date
                    }}</span>
                <mat-icon class="edit-icon" (click)="goToForm()">edit</mat-icon>
            </div>
            <div class="preview-data-item">
                <span class="preview-data-label">Vehículo</span>
                <span class="preview-data-value">{{ stateData?.brandName }} {{ stateData?.modelName }}</span>
                <mat-icon class="edit-icon" (click)="goToHome()">edit</mat-icon>
            </div>
            <div class="preview-data-item">
                <span class="preview-data-label">Matrícula</span>
                <span class="preview-data-value">{{ stateData?.licensePlate }}</span>
                <mat-icon class="edit-icon" (click)="goToHome()">edit</mat-icon>
            </div>
        </div>
        <div class="product-details">
            Incluye:
            <div class="product-detail" *ngFor="let detail of detailsData.all">
                <div class="product-detail-header">{{ detail.title }}
                    <mat-icon *ngIf="expandedDetail != detail.id"
                        (click)="expandedDetail = detail.id">expand_more</mat-icon>
                    <mat-icon *ngIf="expandedDetail == detail.id" (click)="expandedDetail = ''">expand_less</mat-icon>
                </div>
                <div class="product-detail-content" *ngIf="expandedDetail == detail.id">
                    <span [innerHTML]="detail.description"></span>
                </div>
            </div>
            <ng-container *ngIf="stateData?.withAssistance">
                <div class="product-detail" *ngFor="let detail of detailsData.optional">
                    <div class="product-detail-header">{{ detail.title }}
                        <mat-icon *ngIf="expandedDetail != detail.id"
                            (click)="expandedDetail = detail.id">expand_more</mat-icon>
                        <mat-icon *ngIf="expandedDetail == detail.id"
                            (click)="expandedDetail = ''">expand_less</mat-icon>
                    </div>
                    <div class="product-detail-content" *ngIf="expandedDetail == detail.id">
                        <span [innerHTML]="detail.description"></span>
                    </div>
                </div>
            </ng-container>
        </div>
        <div class="product-header">
            <h3>Tomador del seguro</h3>
            <mat-icon class="edit-icon" (click)="goToContractForm()">edit</mat-icon>
        </div>
        <div class="person-wrapper">
            <div class="person-item">
                <div class="person-label">Nombre y apellidos</div>
                <div class="person-value">{{ stateData?.tomador?.name }} {{ stateData?.tomador?.surname1 }} {{
                    stateData?.tomador?.surname2 }}</div>
            </div>
            <div class="person-item">
                <div class="person-label">DNI</div>
                <div class="person-value">{{ stateData?.tomador?.dni }}</div>
            </div>
            <div class="person-item">
                <div class="person-label">Fecha nacimiento</div>
                <div class="person-value">{{ stateData?.tomador?.birthday | date:'d/MM/yyyy' }}</div>
            </div>
            <div class="person-item">
                <div class="person-label">Código postal</div>
                <div class="person-value">{{ stateData?.tomador?.postalCode }}</div>
            </div>
            <div class="person-item">
                <div class="person-label">Dirección</div>
                <div class="person-value">{{ stateData?.tomador?.address }}, {{ stateData?.tomador?.city }}</div>
            </div>
            <div class="person-item">
                <div class="person-label">Email</div>
                <div class="person-value">{{ stateData?.tomador?.email }}</div>
            </div>
        </div>
        <br />
        <div class="product-header">
            <h3>Conductor principal</h3>
            <mat-icon class="edit-icon" (click)="goToContractForm()">edit</mat-icon>
        </div>
        <div class="person-wrapper" *ngIf="stateData?.sameDriverAsTomador">
            Igual que el tomador.
        </div>
        <div class="person-wrapper" *ngIf="!stateData?.sameDriverAsTomador">
            <div class="person-item">
                <div class="person-label">Nombre y apellidos</div>
                <div class="person-value">{{ stateData?.conductor?.name }} {{ stateData?.conductor?.surname1 }} {{
                    stateData?.conductor?.surname2 }}</div>
            </div>
            <div class="person-item">
                <div class="person-label">DNI</div>
                <div class="person-value">{{ stateData?.conductor?.dni }}</div>
            </div>
            <div class="person-item">
                <div class="person-label">Fecha nacimiento</div>
                <div class="person-value">{{ stateData?.conductor?.birthday | date:'d/MM/yyyy' }}</div>
            </div>
        </div>
        <br />
        <div class="product-header">
            <h3>Propietario</h3>
            <mat-icon class="edit-icon" (click)="goToContractForm()">edit</mat-icon>
        </div>
        <div class="person-wrapper" *ngIf="stateData?.sameOwnerAsTomador">
            Igual que el tomador.
        </div>
        <div class="person-wrapper" *ngIf="!stateData?.sameOwnerAsTomador">
            <div class="person-item">
                <div class="person-label">Nombre y apellidos</div>
                <div class="person-value">{{ stateData?.propietari?.name }} {{ stateData?.propietari?.surname1 }} {{
                    stateData?.propietari?.surname2 }}</div>
            </div>
            <div class="person-item">
                <div class="person-label">DNI</div>
                <div class="person-value">{{ stateData?.propietari?.dni }}</div>
            </div>
            <div class="person-item">
                <div class="person-label">Fecha nacimiento</div>
                <div class="person-value">{{ stateData?.propietari?.birthday | date:'d/MM/yyyy' }}</div>
            </div>
        </div>
    </div>
    <br />
    <div class="main-wrapper">
        <br />

        <div class="maintenance-banner" *ngIf="showMaintenanceBlock" role="alert">
            <p><strong>Web en mantenimiento.</strong> Vuelve a intentarlo en unos minutos.</p>
            <p class="maintenance-banner-secondary">
                A partir de las 00:00 podrás contratar con fecha de inicio de mañana.
            </p>
        </div>

        <div class="last-minute-banner" *ngIf="showLastMinuteWarning" role="alert">
            <p>
                <strong>¡Atención!</strong> Debes completar el pago antes de las 00:00. Si lo
                completas más tarde, la fecha de inicio ya habrá pasado y la póliza no podrá
                emitirse: tendrás que volver a empezar la contratación con una nueva fecha.
            </p>
            <mat-checkbox [checked]="lastMinuteConfirmed"
                (change)="lastMinuteConfirmed = $event.checked">
                Entiendo, quiero continuar
            </mat-checkbox>
        </div>

        <button mat-button mat-raised-button color="primary" (click)="pay()"
            [disabled]="paying || showMaintenanceBlock || (showLastMinuteWarning && !lastMinuteConfirmed)"
            style="width: 100% !important;">
            Ir al pago
        </button>
        <br /><br />
    </div>

</mat-card>